import { BooleanExpression } from "./BooleanExpression"
import { IValueExpression } from "../../../../base/models"
import { MUIIcon } from "../../../../widgets"
import Modal from "react-bootstrap/esm/Modal"
import { NumberExpression } from "./NumberExpression"
import { PropertyType } from "../../../../base/types"
import { StringExpression } from "./StringExpression"
import { useState } from "react"

export const EditExpressionDialog = ({ type, entity, expression, onChange, show, hideModal }: {
    type: PropertyType,
    entity?: string,
    expression: IValueExpression,
    show: boolean,
    hideModal: () => void,
    onChange: (expression: IValueExpression) => void
}) => {
    const [localExpression, setLocalExpression] = useState<IValueExpression>({ ...expression })

    return <Modal show={show} onHide={hideModal} dialogClassName="min-w-75 p-20">
        <Modal.Header closeButton className="bg-gray-300 border-0 py-3">
            <h4 className="my-0">Expression</h4>
        </Modal.Header>
        <Modal.Body>
            {(() => {
                switch (type) {
                    case PropertyType.Boolean:
                        return <BooleanExpression
                            entity={entity}
                            expression={localExpression}
                            onChange={(expr) => setLocalExpression(expr)} />
                    case PropertyType.String:
                        return <StringExpression
                            entity={entity}
                            expression={localExpression}
                            onChange={(expr) => setLocalExpression(expr)} />
                    case PropertyType.Number:
                    case PropertyType.Integer:
                        return <NumberExpression
                            entity={entity}
                            expression={localExpression}
                            onChange={(expr) => setLocalExpression(expr)} />
                    default:
                        return <div>Not supported</div>
                }
            })()}
        </Modal.Body>
        <Modal.Footer className="border-0 py-5">
            <button type="button"
                onClick={() => {
                    onChange(localExpression)
                    hideModal()
                }}
                className="btn btn-sm btn-primary py-2">
                <MUIIcon iconName={"SaveOutlined"} className="me-1" />
                OK
            </button>
            <button type="button"
                onClick={hideModal}
                className="btn btn-sm btn-secondary py-2">
                <MUIIcon iconName={"CancelOutlined"} className="me-1" />
                Cancel
            </button>
        </Modal.Footer>
    </Modal>
}
